<!-- 样式一 -->
<ng-template [ngTemplateOutlet]="nzUpload" *ngIf="isEdit && uploadStyle === 1"></ng-template>


<!-- 样式一 -->
<ng-template #nzUpload>
  <div class="clearfix">
    <ng-container *ngIf="uploadHost === 'API'">
      <nz-upload [nzAction]="uploadImgUrl" nzListType="picture" [(nzFileList)]="nzFileList" (nzChange)="handleChange($event)" [nzShowButton]="nzFileList.length < limit" [nzBeforeUpload]="beforeUpload"
                 [nzPreview]="handlePreview" [nzDisabled]="disableUpload" [nzData]="getExtraData" [nzDirectory]="nzDirectory" [nzMultiple]="nzMultiple" [nzShowUploadList]='nzShowUploadList'>
        <div class="upload">
          <button nz-button nzType="default" [disabled]="disableUpload">
            {{placeholder}}
          </button>
        </div>
      </nz-upload>
    </ng-container>

    <ng-container *ngIf="uploadHost === 'KS3'">
      <nz-upload nzListType="picture" nzName="file" [(nzFileList)]="nzFileList" (nzChange)="handleChange($event)" [nzShowButton]="nzFileList.length < limit" [nzBeforeUpload]="beforeUpload"
                 [nzPreview]="handlePreview" [nzDisabled]="disableUpload" [nzData]="getExtraData" [nzDirectory]="nzDirectory" [nzCustomRequest]="customRequestKS3" [nzMultiple]="nzMultiple"
                 [nzRemove]="nzRemove" [nzShowUploadList]='nzShowUploadList'>
        <div class="upload">
          <button nz-button nzType="default" [disabled]="disableUpload">
            {{placeholder}}
          </button>
        </div>
      </nz-upload>
    </ng-container>

    <ng-container *ngIf="uploadHost === 'aliyun'">
      <nz-upload nzListType="picture" nzName="file" [(nzFileList)]="nzFileList" (nzChange)="handleChange($event)" [nzShowButton]="nzFileList.length < limit" [nzBeforeUpload]="beforeUpload"
                 [nzPreview]="handlePreview" [nzDisabled]="disableUpload" [nzData]="getExtraData" [nzDirectory]="nzDirectory" [nzCustomRequest]="customRequestAliyun" [nzMultiple]="nzMultiple"
                 [nzRemove]="nzRemove" [nzShowUploadList]='nzShowUploadList'>
        <div class="upload">
          <button nz-button nzType="default" [disabled]="disableUpload">
            {{placeholder}}
          </button>
        </div>
      </nz-upload>
    </ng-container>

  </div>
  <div *ngIf="fileTypeShow">{{fileType.label}}</div>
  <div *ngIf="fileTypeShow">{{sizeHint}}</div>
</ng-template>

<!-- 样式三 头像框样式 点击上传-->
<ng-container *ngIf="isEdit && uploadStyle === 3">
  <div class="material-library-upload border-none">
    <ng-container *ngIf="uploadHost === 'KS3'">
      <nz-upload nzListType="picture-card"
             nzName="file"
             [nzLimit]="limit"
             [(nzFileList)]="nzFileList"
             (nzChange)="handleChange($event)"
             [nzShowButton]="nzFileList.length < limit"
             [nzBeforeUpload]="beforeUpload"
             [nzPreview]="handlePreview"
             [nzDisabled]="disableUpload"
             [nzData]="getExtraData"
             [nzDirectory]="nzDirectory"
             [nzCustomRequest]="customRequestKS3"
             [nzRemove]="nzRemove"
             [nzShowUploadList]='nzShowUploadList'>

        <div class="material-library-ant-upload pd-25" *ngIf="!nzFileList?.length">
          <i nz-icon nzType="plus" nzTheme="outline" class='fs-30'></i>
          <div class="ant-upload-text mg-t-10">{{placeholder}}</div>
        </div>
      </nz-upload>
    </ng-container>
    <ng-container *ngIf="uploadHost === 'API'">
      <nz-upload nzListType="picture-card"
                 [nzAction]="uploadImgUrl"
                 [(nzFileList)]="nzFileList"
                 (nzChange)="handleChange($event)"
                 [nzShowButton]="nzFileList.length < limit"
                 [nzBeforeUpload]="beforeUpload"
                 [nzPreview]="handlePreview"
                 [nzDisabled]="disableUpload"
                 [nzData]="getExtraData"
                 [nzDirectory]="nzDirectory"
                 [nzMultiple]="nzMultiple"
                 [nzShowUploadList]='nzShowUploadList'>

        <div class="material-library-ant-upload pd-25" *ngIf="!nzFileList?.length">
          <i nz-icon nzType="plus" nzTheme="outline" class='fs-30'></i>
          <div class="ant-upload-text mg-t-10">{{placeholder}}</div>
        </div>
      </nz-upload>
    </ng-container>
  </div>
  <div *ngIf="fileTypeShow">{{fileType.label}}</div>
  <div *ngIf="fileTypeShow">{{sizeHint}}</div>
</ng-container>



<!-- 弹窗预览 -->
<nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null" nzClosable="false" (nzOnCancel)="previewVisible=false">
  <ng-template #modalContent>
    <ng-container *ngIf="previewType === 'image'">
      <img style="width: 100%" [src]="previewUrl" loading="lazy" />
    </ng-container>
    <ng-container *ngIf="previewType === 'video'">
      <video style="width: 100%" [src]="sanitize(previewUrl)" controls>
        您的浏览器不支持 video 标签。
      </video>
    </ng-container>
    <ng-container *ngIf="previewType === 'audio'">
      <audio style="width: 100%" controls>
        <source [src]="sanitize(previewUrl)">
        您的浏览器不支持 audio 标签。
      </audio>
    </ng-container>
  </ng-template>
</nz-modal>


<!-- 查看状态样式 -->
<ng-container *ngIf="!isEdit">
  <div class="material-library-upload">
    <ng-container *ngIf="nzFileList?.length">
      <div class="material-library-ant-upload" *ngFor="let img of nzFileList" (click)='clickCploadMethod()'>
        <div class="overflow-hidden" style="height: 86px; width: 86px;">
          <img src="{{img.url}}" style="width: 100%;" alt="" loading="lazy">
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!nzFileList.length">
      <nz-empty></nz-empty>
    </ng-container>
  </div>
</ng-container>
